import { z } from 'zod'

export const CoercedStringArray = z.preprocess(val => {
  if (typeof val === 'string') {
    return [val]
  }
  return val
}, z.array(z.string()))

export const toArray = <T>(schema: z.ZodType<T>) =>
  z.preprocess(val => {
    if (val === undefined || val === null) return undefined
    return Array.isArray(val) ? val : [val]
  }, z.array(schema))
